export enum CoverageTier {
  EMPLOYEE = 'Employee',
  EMPLOYEE_SPOUSE = 'EmployeeAndSpouse',
  EMPLOYEE_CHILDREN = 'EmployeeAndChildren',
  FAMILY = 'EmployeeAndFamily',
}

export enum CoverageTierToCoverageTierV2 {
  Employee = 'EMPLOYEE',
  EmployeeAndSpouse = 'EMPLOYEE_SPOUSE',
  EmployeeAndChildren = 'EMPLOYEE_CHILD',
  EmployeeAndFamily = 'FAMILY',
}

export const coverageTierV2ToCoverageTierMap = new Map<
  'EMPLOYEE' | 'EMPLOYEE_SPOUSE' | 'EMPLOYEE_CHILD' | 'FAMILY',
  CoverageTier
>([
  ['EMPLOYEE', CoverageTier.EMPLOYEE],
  ['EMPLOYEE_SPOUSE', CoverageTier.EMPLOYEE_SPOUSE],
  ['EMPLOYEE_CHILD', CoverageTier.EMPLOYEE_CHILDREN],
  ['FAMILY', CoverageTier.FAMILY],
]);

export enum Relationship {
  SELF = 'Primary',
  SPOUSE = 'Spouse',
  CHILD = 'Child',
}

export enum RelationshipToRelationshipV2 {
  Primary = 'PRIMARY',
  Spouse = 'SPOUSE',
  Child = 'CHILD',
}

export const relationshipV2ToRelationshipMap = new Map<'PRIMARY' | 'SPOUSE' | 'CHILD', Relationship>([
  ['PRIMARY', Relationship.SELF],
  ['SPOUSE', Relationship.SPOUSE],
  ['CHILD', Relationship.CHILD],
]);

export enum IdentificationCodeType {
  SSN = 'SSN',
  CUSTOM = 'CUSTOM',
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
}

export enum SearchGroup {
  ALL = 'All',
  PRIMARIES = 'Primaries',
  DEPENDENTS = 'Dependents',
}
